"use strict";

var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

const HEADER = document.getElementById("header");

(() => {
	document.documentElement.style.setProperty("--header-height", `${HEADER.clientHeight + HEADER.offsetTop}px`);

	window.onload = () => {
		scrollW();
		window.addEventListener('scroll', scrollW);
	};

	// Remove empty <p> tags created by TinyMCE

	document.querySelectorAll('p').forEach(e => {
		if (e.innerHTML.trim() === '') e.remove();
	});

	// Add custom arrows to lightboxes

	fetch(`${SITE_FILES}svg/arrow.svg`)
		.then(resp => resp.text())
		.then(data => {
			LBX._instances.forEach(lbx => {
				lbx.icons.prev = data;
				lbx.icons.next = data;
			});
		});


	// Split text into individual letter spans

	document.querySelectorAll(".split-text").forEach(element => {
		element.innerHTML = [...element.textContent].map(letter => `<span>${letter}</span>`).join("");
	});

	// ScrollTo Animation

	window.location.hash && animateTo(window.location.hash.substring(1));

	document.querySelectorAll('[href*="#"]:not([data-lbx]').forEach(cta => {
		let target = cta.hash.substring(1);

		if (!document.getElementById(target))
			return;

		cta.addEventListener("click", (e) => {
			e.preventDefault();
			animateTo(target);
		});
	});

	// Toggle Buttons

	document.querySelectorAll(".js-toggle").forEach(btn => {
		let target = document.getElementById(btn.dataset.target);

		if (!target)
			return;

		btn.addEventListener("click", (e) => {
			e.preventDefault();
			target.classList.toggle("active");
		});
	});

	// Set Up Animations

	document.querySelectorAll('.form-module-wrapper') && document.querySelectorAll('.form-module-wrapper').forEach(item => {
		item.classList.add('animate-fade', 'top');
	});

	document.querySelectorAll('.text-modules-wrapper .text-modules') && document.querySelectorAll('.text-modules-wrapper .text-modules').forEach(item => {
		item.classList.add('animate-fade', 'top');
	});

	document.querySelector('.global-sitemap') && document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');

	// Header Navigation Track

	const headerLine = document.getElementById("js-header-line");
	const headerTrack = document.getElementById("js-header-track");

	if (headerLine && headerTrack) {
		const updatePosition = (element) => {
			headerLine.style.cssText = `
				left: ${element ? element.offsetLeft : 0}px;
				width: ${element ? element.offsetWidth : 0}px;
			`;
		}

		const activeEl = headerTrack.querySelector(".active");

		activeEl && document.addEventListener("DOMContentLoaded", () => {
			headerLine.classList.add("has-active");
			updatePosition(activeEl);
			window.addEventListener("resize", () => updatePosition(activeEl));
		});

		headerTrack.addEventListener("mouseover", (e) => {
			let target = e.target.closest("a");

			if (target) {
				headerLine.classList.add("active");

				updatePosition(target);
			}
		});

		headerTrack.addEventListener("mouseout", (e) => {
			headerLine.classList.remove("active");

			activeEl && updatePosition(activeEl);
		});
	}

	// Custom functions

	document.querySelectorAll(".js-offset").forEach(element => {
		element.style.setProperty("--offset", `${element.scrollHeight}px`);
	});

	let prevActiveEl;

	const toggleActiveObserver = new MutationObserver(mutationList => {
		mutationList.forEach(mutation => {
			const target = mutation.target;
			target.nextElementSibling.setAttribute("aria-expanded", target.classList.contains("active"));
		});
	});

	document.querySelectorAll(".js-toggle-active").forEach(element => {
		element.nextElementSibling.hasAttribute("aria-expanded") && toggleActiveObserver.observe(element, { attributes: true, attributeFilter: ["class"] });

		element.addEventListener("click", () => {
			prevActiveEl && prevActiveEl !== element && prevActiveEl.classList.remove("active");
			element.classList.toggle("active");
			prevActiveEl = element;
		});
	});

})();

function scrollW() {
	const scrollTop = document.documentElement.scrollTop;

	if (scrollTop < 80) {
		HEADER.classList.remove('up', 'down');
	} else {
		HEADER.classList.toggle('down', scrollTop > lastScrollTop);
		HEADER.classList.toggle('up', scrollTop <= lastScrollTop);
	}

	lastScrollTop = Math.max(scrollTop, 0);  // Ensure lastScrollTop doesn't go below 0
}

function animateTo(target) {
	const toTarget = document.getElementById(target);

	if (!toTarget)
		return;

	const headerRects = (document.getElementById("header") || document.getElementsByTagName("header")[0]).getBoundingClientRect();
	const from = window.scrollY;
	const to = toTarget.getBoundingClientRect().top + from - (headerRects.height + headerRects.top);
	const duration = 1300;
	const start = performance.now();

	const easeInOutQuart = t => t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;

	function step(timestamp) {
		const time = timestamp - start;
		const progress = Math.min(time / duration, 1);
		const yH = easeInOutQuart(progress) * (to - from) + from;

		window.scrollTo(0, yH);

		time < duration && requestAnimationFrame(step);
	}

	requestAnimationFrame(step);
}

/**Function accordion */
(function(){
	let allAccordionItems = document.getElementsByClassName('js-accordion-title');
	let allALength = allAccordionItems.length;

	if(allALength === 0) return;

	for(let i = 0; i < allALength; i++){
		allAccordionItems[i].addEventListener('click', function(){
			let currentParent = this.parentElement;
			
			let wrapElement = currentParent.querySelector('.wrap');
			let copyElement = currentParent.querySelector('.js-accordion-copy');

			if(!wrapElement || !copyElement) return;

			let currentCopyHeight = wrapElement.clientHeight;

			if(currentParent.classList.contains('open')){
				currentParent.classList.remove('open');
				copyElement.style.height = '0';
			} else {
				currentParent.classList.add('open');
				copyElement.style.height = currentCopyHeight + 'px';
			}
		});
	}
})();
